import {Injectable} from '@angular/core';
import {HttpBackend, HttpClient} from '@angular/common/http';
import {Observable} from 'rxjs';
import {
  ApiCaptchaGetRequest,
  ApiCaptchaGetResponse,
  ApiCaptchaVerifyRequest,
  ApiCaptchaVerifyResponse
} from '@iw-shared/api/captcha';
import {EnvironmentService} from '@iw-shared/core/services/environment.service';

@Injectable({
  providedIn: 'root'
})
export class CaptchaService {
  private httpWithoutInterceptor: HttpClient;

  constructor(private http: HttpClient, private handler: HttpBackend, private environmentService: EnvironmentService) {
    this.httpWithoutInterceptor = new HttpClient(this.handler);
  }

  getRandomCaptcha(): Observable<ApiCaptchaGetResponse> {
    const body: ApiCaptchaGetRequest = {id: 'getCaptcha', command: 'captcha/get'};
    return this.http.post<ApiCaptchaGetResponse>(this.environmentService.environment.urlMainApi, JSON.stringify(body));
  }

  verify(questionId: string, answerId: string): Observable<ApiCaptchaVerifyResponse> {
    const body: ApiCaptchaVerifyRequest = {
      id: 'getCaptcha#INVALID_PARAMS',
      command: 'captcha/verify',
      params: {data: {answerId, questionId}}
    };
    return this.http.post<ApiCaptchaVerifyResponse>(this.environmentService.environment.urlMainApi, JSON.stringify(body));
  }

}
